







































































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { AxiosError } from 'axios';

import {
  Choice,
  NewChoice,
  Question,
  QuestionType
} from '@/models/configurator/question';
import { cloneDeep } from 'lodash';
import { diffDeep } from '@/utils/helpers';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';

export default Vue.extend({
  props: {
    module: [Number]
  },

  components: { ALDialog, ErrorAlert },

  data: () => ({
    questionChoiceTypes: [
      { text: 'Value', value: QuestionType.Value },
      { text: 'Multiple Choice', value: QuestionType.MultipleChoice },
      { text: 'Numeric Choice', value: QuestionType.NumericChoice }
    ],
    QuestionType,

    loading: false,
    createForm: true,
    dialog: false,
    requiredRules: [(v: string) => !!v || 'This field is required'],
    typeRules: [(v: string) => v != null || 'This field is required'],
    valid: true,

    moduleId: (null as unknown) as number,
    question: new Question(),
    questionBackup: null as null | Question,
    errorDetail: {
      text: [],
      type: [],
      hint: [],
      choices: []
    },
    options: {
      type: [
        {
          name: 'Plain Text',
          value: 0
        },

        {
          name: 'Multiple Choice',
          value: 1
        }
      ]
    },

    choices: [] as Choice[],
    newChoice: new Choice(),

    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    questions: get<Question[]>('configuratorQuestion/questions')
  },

  methods: {
    ...mapActions('configuratorQuestion', ['createQuestion', 'updateQuestion']),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async open(question: Question, moduleId: number, createForm = true) {
      this.question = question ? cloneDeep(question) : new Question();
      this.questionBackup = cloneDeep(this.question);
      this.choices = this.question.choices || [];
      this.moduleId = moduleId;
      this.createForm = createForm;
      this.dialog = true;
    },

    close() {
      (this as any).$refs.form.resetValidation();
      this.question = new Question();
      this.dialog = false;
    },

    questionTypeChange(type: number) {
      if (
        (type == QuestionType.MultipleChoice ||
          type == QuestionType.NumericChoice) &&
        !this.question.choices?.length
      ) {
        this.question.choices?.push(new NewChoice());
      }
    },

    parseQuestionForCreate() {
      if (
        this.question.type == QuestionType.MultipleChoice ||
        this.question.type == QuestionType.NumericChoice
      ) {
        this.question.value_option = undefined;
      } else {
        this.question.choices = undefined;
      }
    },

    async save() {
      if ((this as any).$refs.form.validate()) {
        await this.parseQuestionForCreate();
        try {
          if (this.createForm) {
            this.question.module = this.moduleId;

            this.question.order = this.questions.length + 1;

            return await this.createQuestion(this.question).then(() => {
              this.$emit('submitted');
              this.close();
            });
          } else {
            const questionDelta = diffDeep(
              this.question,
              this.questionBackup,
              true
            );

            // update ID and Module numbers used in request URL
            questionDelta.id = this.question.id;
            questionDelta.module = this.question.module;

            return await this.updateQuestion(questionDelta).then(() => {
              this.$emit('submitted');
              this.close();
            });
          }
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.loading = false;
        }
      }
    }
  }
});
